import { Grid, Typography } from '@mui/material';
import { useContext, useEffect, useMemo } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import InputConfig from '../../../../Components/InputConfig';
import useCommonStyles from '../../../../commonStyles';
import { CONFIG_KEYS } from '../../../../core/constants';

const SequentialAdControlDisableConfig = ({ keyData }) => {
	const {
		AGGRESSIVE_AD_REQ_ENABLED,
		TERMINATE_AD_AFTER_DURATION_ENABLED,
		BACKPOCKET_AD_START_DELAY_CONFIG_ENABLED
	} = CONFIG_KEYS;
	const commonStyleClasses = useCommonStyles();

	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const hasPrerequisitesEnabled = useMemo(() => {
		return (
			rawConfig[AGGRESSIVE_AD_REQ_ENABLED] ||
			rawConfig[TERMINATE_AD_AFTER_DURATION_ENABLED] ||
			false
		);
	}, [rawConfig[AGGRESSIVE_AD_REQ_ENABLED], rawConfig[TERMINATE_AD_AFTER_DURATION_ENABLED]]);

	useEffect(() => {
		if (!hasPrerequisitesEnabled && rawConfig[`${keyData}.enabled`]) {
			const cloneRawConfig = structuredClone(rawConfig);
			cloneRawConfig[`${keyData}.enabled`] = false;
			if (
				!rawConfig[AGGRESSIVE_AD_REQ_ENABLED] &&
				rawConfig[BACKPOCKET_AD_START_DELAY_CONFIG_ENABLED]
			) {
				cloneRawConfig[BACKPOCKET_AD_START_DELAY_CONFIG_ENABLED] = false;
			}
			updateRawConfig(cloneRawConfig);
		}
	}, [hasPrerequisitesEnabled]);

	return (
		<Grid item className={commonStyleClasses.basicOutlinedBox}>
			<Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600 }}>
				Sequential Ad Disable Config
			</Typography>
			<Typography variant="body2" sx={{ mb: 2, fontWeight: 600 }}>
				Disables subsequent ad requests and ad termination features once the configured ad fill
				threshold is reached.
			</Typography>

			<Grid container spacing={2} direction="row" sx={{ alignItems: 'center' }}>
				<Grid item>
					<CheckBoxInput
						keyData={`${keyData}.enabled`}
						label="Enabled"
						defaultChecked={false}
						disabled={!hasPrerequisitesEnabled}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item sx={{ width: 'fit-content', ml: 13 }}>
					<InputConfig
						label="Max Ad Fill Count"
						keyData={`${keyData}.maxAdFillCount`}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						inputProps={{ min: 0 }}
						editable={!!rawConfig[`${keyData}.enabled`] && hasPrerequisitesEnabled}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default SequentialAdControlDisableConfig;
